'use client';

import { ThemeProvider } from '../../styles/theme-config/ThemeProvider';
import InfoTile from './InfoTile';

const { Grid } = require('@mui/material');

/**
 * @name InfoTileContainer
 * @param {*} props - Strapi Data
 * @returns {JSX.Element} - Renders InfoTile component
 */
const InfoTileContainer = props => (
  <ThemeProvider palette={props?.cmsData?.Info_Tile_Theme?.theme}>
    <Grid container>
      <InfoTile cmsData={props?.cmsData} handleAction={props.handleAction} />
    </Grid>
  </ThemeProvider>
);
InfoTileContainer.displayName = 'InfoTileContainer';
export default InfoTileContainer;
